declare namespace $ {

	export class $shm_agent_app_messages extends $mol_view {
		rows( ): readonly($mol_view)[]
		sub( ): ReturnType< $shm_agent_app_messages['rows'] >
	}
	
	export class $shm_agent_app_attachments extends $mol_view {
		rows( ): readonly($mol_view)[]
		empty( ): boolean
		attr( ): ({ 
			'hidden': ReturnType< $shm_agent_app_attachments['empty'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): ReturnType< $shm_agent_app_attachments['rows'] >
	}
	
	type $mol_view__sub_shm_agent_app_1 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_title_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_shm_agent_app_6 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__uri_off_shm_agent_app_7 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_uri'] >
		,
		ReturnType< $mol_link['uri_off'] >
	>
	type $mol_link__click_shm_agent_app_8 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_select'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_link__sub_shm_agent_app_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $shm_agent_session_menu__pinned_shm_agent_app_10 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_pinned'] >
		,
		ReturnType< $shm_agent_session_menu['pinned'] >
	>
	type $shm_agent_session_menu__archived_shm_agent_app_11 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_archived'] >
		,
		ReturnType< $shm_agent_session_menu['archived'] >
	>
	type $shm_agent_session_menu__align_shm_agent_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_session_menu['align'] >
	>
	type $shm_agent_session_menu__hint_shm_agent_app_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_session_menu['hint'] >
	>
	type $shm_agent_session_menu__remove_shm_agent_app_14 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_delete'] >
		,
		ReturnType< $shm_agent_session_menu['remove'] >
	>
	type $shm_agent_session_menu__remove_confirm_title_shm_agent_app_15 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_session_menu['remove_confirm_title'] >
	>
	type $mol_string__hint_shm_agent_app_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_agent_app_17 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_tag_new_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_agent_app_18 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_tag_add'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_button_major__title_shm_agent_app_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__sub_shm_agent_app_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_agent_app_21 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_tag_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_agent_app_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_agent_app_23 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_role'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_link__arg_shm_agent_app_24 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_reasoning_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__uri_off_shm_agent_app_25 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_reasoning_uri_off'] >
		,
		ReturnType< $mol_link['uri_off'] >
	>
	type $mol_link__sub_shm_agent_app_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $shm_button_copy__hint_shm_agent_app_27 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_agent_app_28 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_text'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $shm_button_copy__button_sub_shm_agent_app_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_button_copy['button_sub'] >
	>
	type $mol_paragraph__title_shm_agent_app_30 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_time'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_agent_app_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_32 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_agent_app_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_shm_agent_app_34 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_edit_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__sub_shm_agent_app_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_36 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_shm_agent_app_37 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_force_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__sub_shm_agent_app_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_39 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_force'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_agent_app_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_shm_agent_app_41 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_remove_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__sub_shm_agent_app_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_43 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_remove'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__enabled_shm_agent_app_44 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_edit_save_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__sub_shm_agent_app_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_agent_app_46 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_edit_save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__sub_shm_agent_app_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_48 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_edit_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_agent_app_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_agent_app_sessions_head__title_shm_agent_app_50 = $mol_type_enforce<
		ReturnType< $shm_agent_app['sessions_title'] >
		,
		ReturnType< $shm_agent_app_sessions_head['title'] >
	>
	type $shm_agent_app_sessions_head__add_title_shm_agent_app_51 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_app_sessions_head['add_title'] >
	>
	type $shm_agent_app_sessions_head__filter_shm_agent_app_52 = $mol_type_enforce<
		ReturnType< $shm_agent_app['search_query'] >
		,
		ReturnType< $shm_agent_app_sessions_head['filter'] >
	>
	type $shm_agent_app_sessions_head__search_showed_shm_agent_app_53 = $mol_type_enforce<
		ReturnType< $shm_agent_app['search_showed'] >
		,
		ReturnType< $shm_agent_app_sessions_head['search_showed'] >
	>
	type $shm_agent_app_sessions_head__add_shm_agent_app_54 = $mol_type_enforce<
		ReturnType< $shm_agent_app['create'] >
		,
		ReturnType< $shm_agent_app_sessions_head['add'] >
	>
	type $shm_agent_app_sessions_head__close_content_shm_agent_app_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_agent_app_sessions_head['close_content'] >
	>
	type $shm_agent_app_sessions_head__Close_shm_agent_app_56 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_agent_app_sessions_head['Close'] >
	>
	type $shm_agent_app_sessions_head__Settings_shm_agent_app_57 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_agent_app_sessions_head['Settings'] >
	>
	type $mol_page__head_shm_agent_app_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__body_shm_agent_app_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_string_button__value_shm_agent_app_60 = $mol_type_enforce<
		ReturnType< $shm_agent_app['chat_title_draft'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__enabled_shm_agent_app_61 = $mol_type_enforce<
		ReturnType< $shm_agent_app['chat_title_enabled'] >
		,
		ReturnType< $mol_string_button['enabled'] >
	>
	type $mol_string_button__submit_shm_agent_app_62 = $mol_type_enforce<
		ReturnType< $shm_agent_app['chat_title_commit'] >
		,
		ReturnType< $mol_string_button['submit'] >
	>
	type $mol_string_button__event_shm_agent_app_63 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_agent_app['chat_title_commit'] > ): ReturnType< $shm_agent_app['chat_title_commit'] >,
			keydown( next?: ReturnType< $shm_agent_app['chat_title_keydown'] > ): ReturnType< $shm_agent_app['chat_title_keydown'] >,
		})  & ReturnType< $mol_string_button['event'] >
		,
		ReturnType< $mol_string_button['event'] >
	>
	type $shm_agent_app_messages__event_shm_agent_app_64 = $mol_type_enforce<
		({ 
			scroll( next?: ReturnType< $shm_agent_app['messages_scroll'] > ): ReturnType< $shm_agent_app['messages_scroll'] >,
		}) 
		,
		ReturnType< $shm_agent_app_messages['event'] >
	>
	type $shm_agent_app_messages__rows_shm_agent_app_65 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_rows'] >
		,
		ReturnType< $shm_agent_app_messages['rows'] >
	>
	type $mol_view__sub_shm_agent_app_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_agent_app_67 = $mol_type_enforce<
		({ 
			'drag': ReturnType< $shm_agent_app['attachment_drag_active'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_shm_agent_app_68 = $mol_type_enforce<
		({ 
			dragenter( next?: ReturnType< $shm_agent_app['attachment_drag_enter'] > ): ReturnType< $shm_agent_app['attachment_drag_enter'] >,
			dragover( next?: ReturnType< $shm_agent_app['attachment_drag_over'] > ): ReturnType< $shm_agent_app['attachment_drag_over'] >,
			dragleave( next?: ReturnType< $shm_agent_app['attachment_drag_leave'] > ): ReturnType< $shm_agent_app['attachment_drag_leave'] >,
			drop( next?: ReturnType< $shm_agent_app['attachment_drop'] > ): ReturnType< $shm_agent_app['attachment_drop'] >,
		})  & ReturnType< $mol_view['event'] >
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_agent_app_69 = $mol_type_enforce<
		ReturnType< $shm_agent_app['composer_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_content_shm_agent_app_70 = $mol_type_enforce<
		ReturnType< $shm_agent_app['chat_title_content'] >
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__tools_shm_agent_app_71 = $mol_type_enforce<
		ReturnType< $shm_agent_app['chat_tools'] >
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_agent_app_72 = $mol_type_enforce<
		ReturnType< $shm_agent_app['chat_body'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_shm_agent_app_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_button_minor__hint_shm_agent_app_74 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_agent_app_75 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_76 = $mol_type_enforce<
		ReturnType< $shm_agent_app['reasoning_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_shm_agent_app_77 = $mol_type_enforce<
		ReturnType< $shm_agent_app['reasoning_status'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_shm_agent_app_78 = $mol_type_enforce<
		ReturnType< $shm_agent_app['reasoning_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_page__title_shm_agent_app_79 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_agent_app_80 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_agent_app_81 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_agent_history__agent_title_shm_agent_app_82 = $mol_type_enforce<
		ReturnType< $shm_agent_app['agent_name'] >
		,
		ReturnType< $shm_agent_history['agent_title'] >
	>
	type $shm_agent_history__catalog_items_shm_agent_app_83 = $mol_type_enforce<
		ReturnType< $shm_agent_app['history_catalog_items'] >
		,
		ReturnType< $shm_agent_history['catalog_items'] >
	>
	type $shm_agent_history__detail_shm_agent_app_84 = $mol_type_enforce<
		ReturnType< $shm_agent_app['history_detail'] >
		,
		ReturnType< $shm_agent_history['detail'] >
	>
	type $shm_agent_history__selected_shm_agent_app_85 = $mol_type_enforce<
		ReturnType< $shm_agent_app['history_turn_id'] >
		,
		ReturnType< $shm_agent_history['selected'] >
	>
	type $shm_agent_history__has_more_shm_agent_app_86 = $mol_type_enforce<
		ReturnType< $shm_agent_app['history_has_more'] >
		,
		ReturnType< $shm_agent_history['has_more'] >
	>
	type $shm_agent_history__load_more_shm_agent_app_87 = $mol_type_enforce<
		ReturnType< $shm_agent_app['history_load_more'] >
		,
		ReturnType< $shm_agent_history['load_more'] >
	>
	type $shm_agent_history__close_shm_agent_app_88 = $mol_type_enforce<
		ReturnType< $shm_agent_app['history_close'] >
		,
		ReturnType< $shm_agent_history['close'] >
	>
	type $mol_button_minor__hint_shm_agent_app_89 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_fullscreen_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_agent_app_90 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_fullscreen_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_91 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_fullscreen_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_agent_app_92 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_agent_app_93 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_94 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_page__attr_shm_agent_app_95 = $mol_type_enforce<
		({ 
			'fullscreen': ReturnType< $shm_agent_app['file_fullscreen'] >,
		})  & ReturnType< $mol_page['attr'] >
		,
		ReturnType< $mol_page['attr'] >
	>
	type $mol_page__title_shm_agent_app_96 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_agent_app_97 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_agent_app_98 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_content'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_paragraph__title_shm_agent_app_99 = $mol_type_enforce<
		ReturnType< $shm_agent_app['reasoning_part_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $shm_agent_message_text__text_shm_agent_app_100 = $mol_type_enforce<
		ReturnType< $shm_agent_app['reasoning_part_text'] >
		,
		ReturnType< $shm_agent_message_text['text'] >
	>
	type $shm_agent_media__uri_shm_agent_app_101 = $mol_type_enforce<
		ReturnType< $shm_agent_app['attachment_uri'] >
		,
		ReturnType< $shm_agent_media['uri'] >
	>
	type $shm_agent_media__kind_shm_agent_app_102 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_media['kind'] >
	>
	type $mol_text__text_shm_agent_app_103 = $mol_type_enforce<
		ReturnType< $shm_agent_app['attachment_name'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__title_shm_agent_app_104 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_shm_agent_app_105 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_106 = $mol_type_enforce<
		ReturnType< $shm_agent_app['attachment_remove'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_agent_app_sessions__roots_shm_agent_app_107 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_ids'] >
		,
		ReturnType< $shm_agent_app_sessions['roots'] >
	>
	type $shm_agent_app_sessions__locked_shm_agent_app_108 = $mol_type_enforce<
		ReturnType< $shm_agent_app['sessions_drag_locked'] >
		,
		ReturnType< $shm_agent_app_sessions['locked'] >
	>
	type $shm_agent_app_sessions__pinned_shm_agent_app_109 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_pinned'] >
		,
		ReturnType< $shm_agent_app_sessions['pinned'] >
	>
	type $shm_agent_app_sessions__Item_shm_agent_app_110 = $mol_type_enforce<
		ReturnType< $shm_agent_app['Session'] >
		,
		ReturnType< $shm_agent_app_sessions['Item'] >
	>
	type $mol_scroll__sub_shm_agent_app_111 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_view__sub_shm_agent_app_112 = $mol_type_enforce<
		ReturnType< $shm_agent_app['chat_settings_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_113 = $mol_type_enforce<
		ReturnType< $shm_agent_app['sessions_settings_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_agent_app_114 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_limit_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_agent_app_115 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__value_shm_agent_app_116 = $mol_type_enforce<
		ReturnType< $shm_agent_app['agent_model_default_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_shm_agent_app_117 = $mol_type_enforce<
		ReturnType< $shm_agent_app['agent_model_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_shm_agent_app_118 = $mol_type_enforce<
		ReturnType< $shm_agent_app['agent_model_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_agent_app_119 = $mol_type_enforce<
		ReturnType< $shm_agent_app['agent_model_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_shm_agent_app_120 = $mol_type_enforce<
		ReturnType< $shm_agent_app['agent_model_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_shm_agent_app_121 = $mol_type_enforce<
		ReturnType< $shm_agent_app['agent_model_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_icon_target__attr_shm_agent_app_122 = $mol_type_enforce<
		({ 
			'data-status': ReturnType< $shm_agent_app['goal_state'] >,
		})  & ReturnType< $mol_icon_target['attr'] >
		,
		ReturnType< $mol_icon_target['attr'] >
	>
	type $mol_view__sub_shm_agent_app_123 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_124 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_125 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__hint_shm_agent_app_126 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_agent_app_127 = $mol_type_enforce<
		ReturnType< $shm_agent_app['goal_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_button_major__sub_shm_agent_app_128 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_agent_app_129 = $mol_type_enforce<
		ReturnType< $shm_agent_app['goal_set'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__enabled_shm_agent_app_130 = $mol_type_enforce<
		ReturnType< $shm_agent_app['goal_clear_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__sub_shm_agent_app_131 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_132 = $mol_type_enforce<
		ReturnType< $shm_agent_app['goal_clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_agent_app_133 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_134 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_agent_app_135 = $mol_type_enforce<
		({ 
			'current': ReturnType< $shm_agent_app['session_current'] >,
			'archived': ReturnType< $shm_agent_app['session_archived'] >,
			'pinned': ReturnType< $shm_agent_app['session_pinned'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_agent_app_136 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_137 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_agent_app_138 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_tag_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_agent_app_139 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_tag_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_agent_app_140 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_marker_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_141 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_agent_app_142 = $mol_type_enforce<
		({ 
			'title': string,
			'hidden': ReturnType< $shm_agent_app['session_busy_hidden'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__attr_shm_agent_app_143 = $mol_type_enforce<
		({ 
			'title': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_agent_app_144 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_shm_agent_app_145 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_agent_app_146 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_agent_app_147 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_card__theme_shm_agent_app_148 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_theme'] >
		,
		ReturnType< $mol_card['theme'] >
	>
	type $mol_card__attr_shm_agent_app_149 = $mol_type_enforce<
		({ 
			'role': ReturnType< $shm_agent_app['message_role_key'] >,
			'queued': ReturnType< $shm_agent_app['message_queued'] >,
		})  & ReturnType< $mol_card['attr'] >
		,
		ReturnType< $mol_card['attr'] >
	>
	type $mol_card__sub_shm_agent_app_150 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['sub'] >
	>
	type $shm_agent_message_text__text_shm_agent_app_151 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_text'] >
		,
		ReturnType< $shm_agent_message_text['text'] >
	>
	type $shm_agent_message_text__embeds_allowed_shm_agent_app_152 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_embeds_allowed'] >
		,
		ReturnType< $shm_agent_message_text['embeds_allowed'] >
	>
	type $shm_agent_message_text__file_open_shm_agent_app_153 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_file_open'] >
		,
		ReturnType< $shm_agent_message_text['file_open'] >
	>
	type $mol_view__sub_shm_agent_app_154 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_image_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_155 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_video_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_156 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_157 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_158 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_159 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__value_shm_agent_app_160 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_edit_draft'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_shm_agent_app_161 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_view__sub_shm_agent_app_162 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_agent_media__kind_shm_agent_app_163 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_media['kind'] >
	>
	type $shm_agent_media__uri_shm_agent_app_164 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_image_uri'] >
		,
		ReturnType< $shm_agent_media['uri'] >
	>
	type $shm_agent_media__kind_shm_agent_app_165 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_media['kind'] >
	>
	type $shm_agent_media__uri_shm_agent_app_166 = $mol_type_enforce<
		ReturnType< $shm_agent_app['message_video_uri'] >
		,
		ReturnType< $shm_agent_media['uri'] >
	>
	type $mol_view__attr_shm_agent_app_167 = $mol_type_enforce<
		({ 
			'title': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_agent_app_168 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_frame__html_shm_agent_app_169 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_text'] >
		,
		ReturnType< $mol_frame['html'] >
	>
	type $mol_frame__attr_shm_agent_app_170 = $mol_type_enforce<
		({ 
			'sandbox': string,
		})  & ReturnType< $mol_frame['attr'] >
		,
		ReturnType< $mol_frame['attr'] >
	>
	type $mol_text_code__text_shm_agent_app_171 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_text'] >
		,
		ReturnType< $mol_text_code['text'] >
	>
	type $mol_text_code__sidebar_showed_shm_agent_app_172 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_text_code['sidebar_showed'] >
	>
	type $mol_image__uri_shm_agent_app_173 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_data'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_video_player__uri_shm_agent_app_174 = $mol_type_enforce<
		ReturnType< $shm_agent_app['file_data'] >
		,
		ReturnType< $mol_video_player['uri'] >
	>
	type $mol_video_player__autoplay_shm_agent_app_175 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['autoplay'] >
	>
	type $mol_video_player__controls_shm_agent_app_176 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['controls'] >
	>
	type $mol_video_player__muted_shm_agent_app_177 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['muted'] >
	>
	type $mol_card__sub_shm_agent_app_178 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['sub'] >
	>
	type $shm_agent_app_attachments__empty_shm_agent_app_179 = $mol_type_enforce<
		ReturnType< $shm_agent_app['attachments_empty'] >
		,
		ReturnType< $shm_agent_app_attachments['empty'] >
	>
	type $shm_agent_app_attachments__rows_shm_agent_app_180 = $mol_type_enforce<
		ReturnType< $shm_agent_app['attachment_rows'] >
		,
		ReturnType< $shm_agent_app_attachments['rows'] >
	>
	type $mol_view__sub_shm_agent_app_181 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_182 = $mol_type_enforce<
		ReturnType< $shm_agent_app['composer_row_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_agent_app_183 = $mol_type_enforce<
		({ 
			'busy': ReturnType< $shm_agent_app['busy'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_agent_app_184 = $mol_type_enforce<
		ReturnType< $shm_agent_app['composer_action_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_185 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__hint_shm_agent_app_186 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_agent_app_187 = $mol_type_enforce<
		ReturnType< $shm_agent_app['prompt'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__event_shm_agent_app_188 = $mol_type_enforce<
		({ 
			paste( next?: ReturnType< $shm_agent_app['attachment_paste'] > ): ReturnType< $shm_agent_app['attachment_paste'] >,
		})  & ReturnType< $mol_textarea['event'] >
		,
		ReturnType< $mol_textarea['event'] >
	>
	type $mol_textarea__submit_shm_agent_app_189 = $mol_type_enforce<
		ReturnType< $shm_agent_app['steer'] >
		,
		ReturnType< $mol_textarea['submit'] >
	>
	type $mol_button_minor__hint_shm_agent_app_190 = $mol_type_enforce<
		ReturnType< $shm_agent_app['send_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_agent_app_191 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_192 = $mol_type_enforce<
		ReturnType< $shm_agent_app['send'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_agent_app_193 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_shm_agent_app_194 = $mol_type_enforce<
		ReturnType< $shm_agent_app['stop_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__sub_shm_agent_app_195 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_196 = $mol_type_enforce<
		ReturnType< $shm_agent_app['stop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_agent_app_197 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_agent_app_198 = $mol_type_enforce<
		({ 
			'standalone': ReturnType< $shm_agent_app['sessions_page_visible'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_agent_app_199 = $mol_type_enforce<
		ReturnType< $shm_agent_app['sessions_panel_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_agent_app_200 = $mol_type_enforce<
		ReturnType< $shm_agent_app['tag_filter_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_agent_app_201 = $mol_type_enforce<
		ReturnType< $shm_agent_app['tag_filter_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_agent_app_202 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_app_203 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_shm_agent_app_204 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_shm_agent_app_205 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_shm_agent_app_206 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_agent_app_207 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_pick__hint_shm_agent_app_208 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_shm_agent_app_209 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_shm_agent_app_210 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_agent_app_211 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_labeler__title_shm_agent_app_212 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_agent_app_213 = $mol_type_enforce<
		ReturnType< $shm_agent_app['Sessions_limits'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_labeler__title_shm_agent_app_214 = $mol_type_enforce<
		ReturnType< $shm_agent_app['session_limit_title'] >
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_agent_app_215 = $mol_type_enforce<
		ReturnType< $shm_agent_app['Session_limit_value'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_labeler__title_shm_agent_app_216 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_agent_app_217 = $mol_type_enforce<
		ReturnType< $shm_agent_app['Sessions_model'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_check_box__title_shm_agent_app_218 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_agent_app_219 = $mol_type_enforce<
		ReturnType< $shm_agent_app['agent_fast_default_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_icon__hint_shm_agent_app_220 = $mol_type_enforce<
		ReturnType< $shm_agent_app['intermediate_toggle_hint'] >
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_shm_agent_app_221 = $mol_type_enforce<
		ReturnType< $shm_agent_app['intermediate_hidden'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_agent_app_222 = $mol_type_enforce<
		ReturnType< $shm_agent_app['Intermediate_toggle_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_button_minor__hint_shm_agent_app_223 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_agent_app_224 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_225 = $mol_type_enforce<
		ReturnType< $shm_agent_app['history_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_labeler__title_shm_agent_app_226 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_agent_app_227 = $mol_type_enforce<
		ReturnType< $shm_agent_app['Model'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_check_box__title_shm_agent_app_228 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_agent_app_229 = $mol_type_enforce<
		ReturnType< $shm_agent_app['agent_fast_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_shm_agent_app_230 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_agent_app_231 = $mol_type_enforce<
		ReturnType< $shm_agent_app['fork_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__sub_shm_agent_app_232 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_app_233 = $mol_type_enforce<
		ReturnType< $shm_agent_app['fork'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_pick__hint_shm_agent_app_234 = $mol_type_enforce<
		ReturnType< $shm_agent_app['goal_hint'] >
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__attr_shm_agent_app_235 = $mol_type_enforce<
		({ 
			'data-status': ReturnType< $shm_agent_app['goal_state'] >,
		})  & ReturnType< $mol_pick['attr'] >
		,
		ReturnType< $mol_pick['attr'] >
	>
	type $mol_pick__trigger_content_shm_agent_app_236 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_agent_app_237 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	export class $shm_agent_app extends $mol_book2 {
		file_keydown( next?: any ): any
		session_current( id: any): boolean
		session_archived( id: any, next?: boolean ): boolean
		session_pinned( id: any, next?: boolean ): boolean
		session_arg( id: any): Record<string, any>
		session_uri( id: any): string
		session_select( id: any, next?: any ): any
		session_title_rows( id: any): readonly(any)[]
		Session_title_row( id: any): $mol_view
		session_meta( id: any): string
		Session_meta_text( id: any): $mol_view
		session_tags_label( id: any): string
		Session_tags( id: any): $mol_view
		Session_meta( id: any): $mol_view
		Session_info( id: any): $mol_view
		Session_link( id: any): $mol_link
		session_delete( id: any, next?: any ): any
		Session_menu( id: any): $shm_agent_session_menu
		session_tag_new_value( id: any, next?: string ): string
		session_tag_add( id: any, next?: any ): any
		Session_tag_new( id: any): $mol_string
		Session_tag_add( id: any): $mol_button_major
		session_tag_title( id: any): string
		session_tag_checked( id: any, next?: boolean ): boolean
		session_marker_rows( id: any): readonly(any)[]
		session_title( id: any): string
		session_busy_hidden( id: any): boolean
		session_current_title( ): string
		Sessions_current( ): $mol_view
		message_theme( id: any): string
		message_role_key( id: any): string
		message_queued( id: any): boolean
		message_role( id: any): string
		Message_role( id: any): $mol_paragraph
		message_reasoning_arg( id: any): Record<string, any>
		message_reasoning_uri_off( id: any): string
		message_reasoning_title( id: any): string
		Message_reasoning_link( id: any): $mol_link
		message_text( id: any): string
		Message_copy( id: any): $shm_button_copy
		message_time( id: any): string
		Message_time( id: any): $mol_paragraph
		Message_head( id: any): $mol_view
		message_content( id: any): readonly(any)[]
		Message_text_box( id: any): $mol_view
		message_embeds_allowed( id: any): boolean
		message_file_open( id: any, next?: any ): any
		message_image_rows( id: any): readonly(any)[]
		message_video_rows( id: any): readonly(any)[]
		message_error( id: any): string
		message_state( id: any): string
		message_edit_enabled( id: any): boolean
		message_edit( id: any, next?: any ): any
		Message_edit( id: any): $mol_button_minor
		message_force_enabled( id: any): boolean
		message_force( id: any, next?: any ): any
		Message_force( id: any): $mol_button_minor
		message_remove_enabled( id: any): boolean
		message_remove( id: any, next?: any ): any
		Message_remove( id: any): $mol_button_minor
		message_edit_draft( id: any, next?: string ): string
		message_edit_save_enabled( id: any): boolean
		message_edit_save( id: any, next?: any ): any
		Message_edit_save( id: any): $mol_button_major
		message_edit_cancel( id: any, next?: any ): any
		Message_edit_cancel( id: any): $mol_button_minor
		message_image_uri( id: any): string
		message_video_uri( id: any): string
		reply_elapsed( id: any): string
		Reply_elapsed( id: any): $mol_view
		Reply_dots( id: any): $shm_dotsloader
		sessions_title( ): string
		search_query( next?: string ): string
		search_showed( ): boolean
		create( next?: any ): any
		Sessions_head( ): $shm_agent_app_sessions_head
		Sessions_page( ): $mol_page
		chat_title_draft( next?: string ): string
		chat_title_enabled( ): boolean
		chat_title_commit( next?: any ): any
		chat_title_keydown( next?: any ): any
		Chat_title( ): $mol_string_button
		chat_title_content( ): readonly(any)[]
		chat_tools( ): readonly(any)[]
		messages_scroll( next?: any ): any
		message_rows( id: any): readonly(any)[]
		Messages( id: any): $shm_agent_app_messages
		Messages_box( id: any): $mol_view
		chat_body( ): readonly(any)[]
		attachment_drag_active( ): boolean
		attachment_drag_enter( next?: any ): any
		attachment_drag_over( next?: any ): any
		attachment_drag_leave( next?: any ): any
		attachment_drop( next?: any ): any
		composer_content( ): readonly(any)[]
		Composer( ): $mol_view
		Chat_page( ): $mol_page
		reasoning_close( next?: any ): any
		Reasoning_close( ): $mol_button_minor
		reasoning_status( ): string
		Reasoning_status( ): $mol_paragraph
		reasoning_rows( ): readonly(any)[]
		Reasoning_parts( ): $mol_list
		Reasoning_page( ): $mol_page
		agent_name( ): string
		history_catalog_items( ): readonly(any)[]
		history_detail( ): any
		history_turn_id( next?: string ): string
		history_has_more( ): boolean
		history_load_more( next?: any ): any
		history_close( next?: any ): any
		History_page( ): $shm_agent_history
		file_title( ): string
		file_fullscreen_hint( ): string
		file_fullscreen_content( ): readonly(any)[]
		file_fullscreen_toggle( next?: any ): any
		File_fullscreen( ): $mol_button_minor
		file_close( next?: any ): any
		File_close( ): $mol_button_minor
		file_content( ): readonly(any)[]
		File_page( ): $mol_page
		app_pages( ): readonly(any)[]
		file_text( id: any): string
		file_data( id: any): string
		reasoning_part_title( id: any): string
		Reasoning_part_title( id: any): $mol_paragraph
		reasoning_part_text( id: any): string
		Reasoning_part_text( id: any): $shm_agent_message_text
		attachments_empty( ): boolean
		attachment_rows( ): readonly(any)[]
		attachment_uri( id: any): string
		Attachment_image( id: any): $shm_agent_media
		attachment_name( id: any): string
		Attachment_name( id: any): $mol_text
		Attachment_remove_icon( id: any): $mol_icon_close
		attachment_remove( id: any, next?: any ): any
		Attachment_remove( id: any): $mol_button_minor
		composer_row_content( ): readonly(any)[]
		busy( ): boolean
		composer_action_rows( ): readonly(any)[]
		activity_error( ): string
		prompt( next?: string ): string
		attachment_paste( next?: any ): any
		steer( next?: any ): any
		send_hint( ): string
		send( next?: any ): any
		stop_enabled( ): boolean
		stop( next?: any ): any
		sessions_page_visible( ): boolean
		session_ids( next?: readonly(string)[] ): readonly(string)[]
		sessions_drag_locked( ): boolean
		Sessions( ): $shm_agent_app_sessions
		Sessions_scroll( ): $mol_scroll
		sessions_panel_rows( ): readonly(any)[]
		tag_filter_title( id: any): string
		tag_filter_checked( id: any, next?: boolean ): boolean
		chat_provider( ): string
		chat_settings_rows( ): readonly(any)[]
		Chat_settings_content( ): $mol_view
		sessions_settings_rows( ): readonly(any)[]
		Sessions_settings_content( ): $mol_view
		session_limit_rows( ): readonly(any)[]
		Sessions_limits( ): $mol_list
		session_limit_title( id: any): string
		session_limit_value( id: any): string
		Session_limit_value( id: any): $mol_view
		agent_model_default_id( next?: string ): string
		agent_model_options( ): readonly(any)[]
		agent_model_dict( ): Record<string, any>
		Sessions_model( ): $mol_select
		agent_fast_default_enabled( next?: boolean ): boolean
		intermediate_toggle_hint( ): string
		intermediate_hidden( next?: boolean ): boolean
		history_open( next?: any ): any
		agent_model_id( next?: string ): string
		Model( ): $mol_select
		agent_fast_enabled( next?: boolean ): boolean
		fork_enabled( ): boolean
		fork( next?: any ): any
		goal_hint( ): string
		goal_state( ): string
		Goal_settings_icon( ): $mol_icon_target
		Goal_title( ): $mol_view
		goal_status( ): string
		Goal_status( ): $mol_view
		Goal_head( ): $mol_view
		goal_text( next?: string ): string
		Goal_input( ): $mol_textarea
		goal_set( next?: any ): any
		Goal_set( ): $mol_button_major
		goal_clear_enabled( ): boolean
		goal_clear_title( ): string
		goal_clear( next?: any ): any
		Goal_clear( ): $mol_button_minor
		Goal_actions( ): $mol_view
		Goal( ): $mol_view
		event( ): ({ 
			keydown( next?: ReturnType< $shm_agent_app['file_keydown'] > ): ReturnType< $shm_agent_app['file_keydown'] >,
		})  & ReturnType< $mol_book2['event'] >
		session_id( next?: string ): string
		session_rows( ): readonly($mol_view)[]
		session_order_scope( ): string
		server_url( ): string
		new_session_title( next?: string ): string
		file_fullscreen( next?: boolean ): boolean
		attachments( next?: readonly($shm_agent_attachment)[] ): readonly($shm_agent_attachment)[]
		message_items( ): readonly(any)[]
		message_image_uri_resolve( id: any): string
		message_video_uri_resolve( id: any): string
		session_by_id( id: any, next?: any ): any
		session_upsert( next?: any ): any
		thread_data( next?: any ): any
		chat_title( ): string
		Send_icon( ): $mol_icon_send
		Stop_icon( ): $mol_icon_stop
		Fork_icon( ): $mol_icon_source_fork
		Chat_settings_icon( ): $mol_icon_dots_vertical
		Sessions_settings_icon( ): $mol_icon_dots_vertical
		Tags_filter_icon( ): $mol_icon_dots_vertical
		Session_tag_add_icon( id: any): $mol_icon_plus
		Message_reasoning_icon( id: any): $mol_icon_eye
		Message_copy_icon( id: any): $mol_icon_content_copy
		Message_edit_icon( id: any): $mol_icon_comment_edit_outline
		Message_remove_icon( id: any): $mol_icon_close
		Intermediate_toggle_icon( ): $mol_icon_collapse_all
		History_icon( ): $mol_icon_archive_clock_outline
		Reasoning_close_icon( ): $mol_icon_close
		File_close_icon( ): $mol_icon_close
		File_fullscreen_icon( ): $mol_icon_fullscreen
		File_fullscreen_exit_icon( ): $mol_icon_fullscreen_exit
		Session( id: any): $mol_view
		Session_tag_new_bar( id: any): $mol_view
		Session_tag_check( id: any): $mol_check_box
		Session_markers( id: any): $mol_view
		Session_title( id: any): $mol_view
		Session_busy( id: any): $mol_view
		Session_unread( id: any): $mol_view
		Sessions_pick( ): $mol_pick
		Message( id: any): $mol_card
		Message_text( id: any): $shm_agent_message_text
		Message_images( id: any): $mol_view
		Message_videos( id: any): $mol_view
		Message_error( id: any): $mol_view
		Message_state( id: any): $mol_view
		Message_queue( id: any): $mol_view
		Message_actions( id: any): $mol_view
		Message_editor( id: any): $mol_textarea
		Message_edit_actions( id: any): $mol_view
		message_editing( id: any, next?: boolean ): boolean
		Message_image( id: any): $shm_agent_media
		Message_video( id: any): $shm_agent_media
		Reply_loader( id: any): $mol_view
		pages( ): ReturnType< $shm_agent_app['app_pages'] >
		File_frame( id: any): $mol_frame
		File_code( id: any): $mol_text_code
		File_image( id: any): $mol_image
		File_video( id: any): $mol_video_player
		Reasoning_part( id: any): $mol_card
		Composer_attachments( ): $shm_agent_app_attachments
		Attachment( id: any): $mol_view
		Composer_row( ): $mol_view
		Composer_actions( ): $mol_view
		Activity_error( ): $mol_view
		Prompt( ): $mol_textarea
		Send( ): $mol_button_minor
		Stop( ): $mol_button_minor
		No_session( ): $mol_view
		Sessions_panel( ): $mol_view
		Tag_filter_check( id: any): $mol_check_box
		Tags_filter_empty( ): $mol_view
		Chat_provider( ): $mol_view
		Chat_settings( ): $mol_pick
		Sessions_settings( ): $mol_pick
		Sessions_limits_label( ): $mol_labeler
		Session_limit( id: any): $mol_labeler
		Sessions_model_label( ): $mol_labeler
		Sessions_fast( ): $mol_check_box
		Intermediate_toggle( ): $mol_check_icon
		History_toggle( ): $mol_button_minor
		Model_label( ): $mol_labeler
		Session_fast( ): $mol_check_box
		Fork( ): $mol_button_minor
		Goal_settings( ): $mol_pick
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map